// Client-side image resize → JPEG data URL (~50KB) and Google Drive URL helpers

export async function resizeImageToDataURL(file, { maxEdge = 800, quality = 0.82 } = {}) {
  const bitmap = await createImageBitmap(file);
  const w = bitmap.width;
  const h = bitmap.height;
  let outW = w;
  let outH = h;
  if (Math.max(w, h) > maxEdge) {
    if (w >= h) {
      outW = maxEdge;
      outH = Math.round((h * maxEdge) / w);
    } else {
      outH = maxEdge;
      outW = Math.round((w * maxEdge) / h);
    }
  }
  const canvas = document.createElement("canvas");
  canvas.width = outW;
  canvas.height = outH;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(bitmap, 0, 0, outW, outH);
  return canvas.toDataURL("image/jpeg", quality);
}

// Accepts a variety of Google Drive share URLs and returns the file id.
// Supported:
//   https://drive.google.com/file/d/FILE_ID/view?usp=sharing
//   https://drive.google.com/open?id=FILE_ID
//   https://drive.google.com/uc?id=FILE_ID&export=download
export function parseDriveFileId(url) {
  if (!url) return null;
  const u = url.trim();
  const fileMatch = u.match(/\/file\/d\/([A-Za-z0-9_-]+)/);
  if (fileMatch) return fileMatch[1];
  const idParam = u.match(/[?&]id=([A-Za-z0-9_-]+)/);
  if (idParam) return idParam[1];
  return null;
}

export function driveEmbedUrl(url) {
  const id = parseDriveFileId(url);
  return id ? `https://drive.google.com/file/d/${id}/preview` : null;
}

export function driveThumbnailUrl(url, size = 320) {
  const id = parseDriveFileId(url);
  return id ? `https://drive.google.com/thumbnail?id=${id}&sz=w${size}` : null;
}

let _idCounter = 0;
export function makeMediaId() {
  _idCounter += 1;
  return `m_${Date.now().toString(36)}_${_idCounter}`;
}
